import React from 'react';

import { Container } from './styles';
import { services } from './props';

import ServiceCard from '../service-card';

function OurServices() {
  return (
    <Container>
      <div className="divider">
        <div />
        <div />
        <div />
      </div>
      <div className="info">
        <h3 className="info__title">Nossos Serviços</h3>
        <span className="info__description">
          O Juslabore está crescendo cada vez mais e nossos serviços não deixam
          por menos.
        </span>
      </div>

      <div className="cards">
        {services.map((service, index) => (
          <ServiceCard key={service.title + index} {...service} />
        ))}
      </div>
    </Container>
  );
}

export default OurServices;
